import { isMobileAtom, useRecoil } from '@orcar/common-d2c';
import FamilyMobileReservationInfo from '@/assets/img/img_family-reservation-info-mobile.svg';
import RentChargeInfo from './RentChargeInfo';
import ReservationInfo from './ReservationInfo';
import ShuttleInfo from './ShuttleInfo';
import * as S from '../styles';

const RentConditionInfo = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  return (
    <>
      {isMobile ? (
        <img
          src={FamilyMobileReservationInfo}
          alt='모바일버전 대여 조건 안내 이미지'
        />
      ) : (
        <S.Wrapper isMobile={isMobile}>
          <S.Wrapper isMobile={isMobile} isConnect>
            <ShuttleInfo />
            <S.Title type='page'>대여 조건 및 대여 불가</S.Title>
            <S.Section type='main'>
              <S.Title type='reservation'>[대여 조건]</S.Title>

              <S.Section type='text'>
                <S.Text type='highlight'>
                  ※ 임차인은 렌트카를 인도받은 시점부터 회사에 반환하는 시점까지
                  선량한 관리자의 주의의무를 다하여 렌트카를 사용하고 보관하여야
                  합니다.
                  <br />※ 실제 운전할 자의 운전면허증을 반드시 지참해야 합니다.
                </S.Text>
              </S.Section>

              <S.Section type='paragraph'>
                <S.Title type='section'>1. 내국인 2. 외국인</S.Title>
                <S.Section type='text'>
                  <S.Text type='main'>
                    - 도로교통법상 유효한 운전면허증 소지자 <br />
                    - 외국인의 경우, 한국어로 소통이 가능하고 즉시 연락 가능한
                    핸드폰 소지자 <br />- 국제면허증 대여 불가
                  </S.Text>
                </S.Section>
              </S.Section>

              <S.Section type='paragraph'>
                <S.Title type='section'>3. 나이 및 경력이 충족한 자</S.Title>
                <S.Section type='text'>
                  <S.Text type='main'>
                    - 쏠라티를 제외한 전차종 만 26세 이상, 면허 취득일로부터 1년
                    이상 경과하고 적성 검사 기간이 남아있는 자 <br />- 쏠라티
                    15인승의 경우 만 30세 이상, 면허 취득일로부터 1년 이상
                    경과하고 적성 검사 기간이 남아있는 자
                    <br /> <br />* 단, 11인승 이상인 경우 1종 보통 이상 면허
                    필수
                  </S.Text>
                </S.Section>
              </S.Section>

              <S.Section type='paragraph'>
                <S.Title type='section'>4. 차량 인수・반납 가능 시간</S.Title>
                <S.Section type='text'>
                  <S.Text type='main'>
                    {'1) 인수 가능 시간'}
                    <br />
                    <S.Text type='highlight'> * 08:00~21:00 내에서 가능</S.Text>
                    <br />
                    * 08:00 이전 인수 불가
                    <br />
                    * 21:00 이후 인수 불가
                    <br />
                    <br />
                    {'2) 반납 가능 시간'}
                    <br />
                    <S.Text type='highlight'>* 07:00~20:00 내에서 가능</S.Text>
                    <br />
                    * 20:00 이후 반납 불가
                    <br />
                    <S.Text type='highlight'>
                      * 07:00~08:00 반납 시 고급 면책 보험 가입 및 사전 고지
                      필수
                    </S.Text>
                    <br />
                    <S.Text type='highlight'>
                      * 사고 발생으로 보험 소멸 시 새벽 반납 불가
                    </S.Text>
                  </S.Text>
                </S.Section>
              </S.Section>
            </S.Section>
            <S.Section type='main'>
              <S.Title type='reservation'>[대여 불가]</S.Title>

              <S.Section type='text'>
                <S.Text type='main'>
                  ※ 차량 임차 시 대여 조건 불충분인 경우 또는 대여 불가 항목에
                  해당하는 경우 예약금 및 환불 규정 참조
                  <br />
                  <br />
                </S.Text>
                <S.Text type='highlight'>
                  1. 차량 인수 시 탑승 인원(영유아 포함) 초과될 경우 <br />
                  2. 차량 인수 시 반려동물 동승한 경우 <br />
                  3. 낚시 관련 도구를 지참한 경우 <br />
                  4. 임차예정 시간 기준 2시간 이상 연락 두절된 경우 <br />
                  5. 당사의 요청 사항 및 자료 요구에 불응할 경우 <br />
                  6. 기타 당사의 합리적, 보편적인 판단에 의거 차량 대여가 불가한
                  사항일 경우 <br />
                </S.Text>
              </S.Section>
            </S.Section>
          </S.Wrapper>
          <RentChargeInfo />
          <ReservationInfo />
        </S.Wrapper>
      )}
    </>
  );
};

export default RentConditionInfo;
